import formatCPF from '../../utils/functions/formatCPF';
import formatCNPJ from '../../utils/functions/formatCNPJ';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import verifyEmptyValues from '../../utils/verifyEmptyValues';
import renderCodeStatus from '../../utils/renderCodeStatus';
import * as dayjs from 'dayjs';

export default function convertObjToArray(data) {
  const {
    CODOPERACAO,
    STATUS_DESCRICAO,
    STATUS,
    NOME,
    CPFCNPJ,
    DATA_HORA,
    VALOR,
    TAXA,
    PRIMEIRO_VENCIMENTO,
  } = data;

  const loanDetailArray = [
    {
      name: 'Código da Operação',
      value: verifyEmptyValues(CODOPERACAO),
    },
    {
      name: 'Status',
      value: STATUS ? (
        <StatusContainer
          code={renderCodeStatus(STATUS_DESCRICAO)}
          description={STATUS_DESCRICAO}
        ></StatusContainer>
      ) : (
        '-----'
      ),
    },
    {
      name: 'CPF/CNPJ',
      value: CPFCNPJ
        ? CPFCNPJ.length === 11
          ? formatCPF(CPFCNPJ)
          : formatCNPJ(CPFCNPJ)
        : '-----',
    },
    {
      name: 'Nome',
      value: verifyEmptyValues(NOME),
    },
    {
      name: 'Data/Hora',
      value: DATA_HORA || '-----',
    },
    { name: 'Taxa', value: TAXA ? 'R$ ' + formatMoney(TAXA) : '-----' },
    { name: 'Valor', value: VALOR ? 'R$ ' + formatMoney(VALOR) : '-----' },
    {
      name: 'Primeiro vencimento',
      value: dayjs(PRIMEIRO_VENCIMENTO).format('DD/MM/YYYY') || '-----',
    },
  ];
  return loanDetailArray;
}
